module.exports = __webpack_public_path__ + "img/mind_element_more.fb1444ab.png";